<template>
  <div id="blog" style="padding-top: 20px">
    <articles>
      <banner />
    </articles>
  </div>
</template>

<script>
export default {
    components: {
      Articles: () => import('@/components/blog/Articles'),
      Banner: () => import('@/components/blog/Banner'),
    },
}
</script>

<style>

</style>